import { SALES_OUTSTANDING_REPORT_FAILURE, SALES_OUTSTANDING_REPORT_REQUEST, SALES_OUTSTANDING_REPORT_SUCCESS, SALES_OUTSTANDING_REPORT_MAIL_WHATSAPP_FAILURE, SALES_OUTSTANDING_REPORT_MAIL_WHATSAPP_REQUEST, SALES_OUTSTANDING_REPORT_MAIL_WHATSAPP_SUCCESS, SALES_OUTSTANDING_REPORT_REQUEST_FAILURE, SALES_OUTSTANDING_REPORT_REQUEST_SUCCESS, SALES_OUTSTANDING_FILTER_REPORT_REQUEST, SALES_OUTSTANDING_FILTER_REPORT_SUCCESS, SALES_OUTSTANDING_FILTER_REPORT_FAILURE } from "../types";
  
  const initialState = {
    salesOutstandingReport: {},
    salesOutstandingReportMailWhatsapp: {},
    salesOutstandingReportFilter: {},
    loading: false,
    error: null,
  };
  
  const salesOutstandingReportReducer = (state = initialState, action) => {
    switch (action.type) {
      case SALES_OUTSTANDING_REPORT_REQUEST: {
        return {
          ...state,
          loading: true,
          salesOutstandingReport: {},
          error: null
        };
      }
      case SALES_OUTSTANDING_REPORT_SUCCESS: {
        return {
          ...state,
          salesOutstandingReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case SALES_OUTSTANDING_REPORT_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        };
      }
      case SALES_OUTSTANDING_REPORT_MAIL_WHATSAPP_REQUEST: {
        return {
          ...state,
          loading: true,
          salesOutstandingReportMailWhatsapp: {},
          error: null
        };
      }
      case SALES_OUTSTANDING_REPORT_MAIL_WHATSAPP_SUCCESS: {
        return {
          ...state,
          salesOutstandingReportMailWhatsapp: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case SALES_OUTSTANDING_REPORT_MAIL_WHATSAPP_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        };
      }
      case SALES_OUTSTANDING_REPORT_REQUEST_SUCCESS: {
        return {
          ...state,
          loading: false,
          error: null
        }
      }
      case SALES_OUTSTANDING_REPORT_REQUEST_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        }
      }
      case SALES_OUTSTANDING_FILTER_REPORT_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        }
      }
      case SALES_OUTSTANDING_FILTER_REPORT_SUCCESS: {
        return {
          ...state,
          salesOutstandingReportFilter: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case SALES_OUTSTANDING_FILTER_REPORT_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        }
      }
      default:
        return state;
    }
  };
  
  export default salesOutstandingReportReducer;
  